// types/timeoff.ts

export interface LeaveBalance {
  policyId: number;
  name: string;
  policyDisplayName: string;
  ukEmployerEmployeeId: number;
  leaveTypeVersionId: number;
  balance: number;
}

// Form values - what the form component uses internally
export interface TimeOffFormValues {
  leaveTypeVersionId: number;
  startDate: Date;
  endDate: Date;
  hours?: number;
  reason?: string;
}

// API Request - what gets sent to the server
export interface TimeOffRequest {
  leaveTypeVersionId: number;
  startDate: string;
  endDate: string;
  hours?: number;
  reason?: string;
  ukEmployerEmployeeId?: number;
  requiresApproval?: boolean;
}

// Helper function to convert form values to API request
export const convertFormToRequest = (
  values: TimeOffFormValues,
  ukEmployerEmployeeId?: number,
  requiresApproval?: boolean,
): TimeOffRequest => ({
  leaveTypeVersionId: values.leaveTypeVersionId,
  startDate: values.startDate.toISOString(),
  endDate: values.endDate.toISOString(),
  hours: values.hours,
  reason: values.reason,
  ...(ukEmployerEmployeeId ? { ukEmployerEmployeeId } : {}),
  ...(requiresApproval !== undefined ? { requiresApproval } : {}),
});
